import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonCard = () => {
    return (
      <ul className="list">
          {Array(6).fill().map((item, index) => (
          <div style={{display:"flex", justifyContent:"space-between", marginTop:"20px"}}>
            <SkeletonTheme className="card grid-stack-item-content">
              <Skeleton className="mr-1 grid-stack-item" height={300} width={700} />
            </SkeletonTheme>
            <SkeletonTheme className="card grid-stack-item-content">
              <Skeleton className="mr-1 grid-stack-item" height={300} width={700} />
            </SkeletonTheme>
          </div>
   ))}
</ul>
    );
  };
  export default SkeletonCard;
